/* tslint:disable */
/* eslint-disable */
/**
 * openapi
 * bales cloud
 *
 * The version of the OpenAPI document: 1.0
 * Contact: test@example.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { SendgridDomain } from '../models';
/**
 * SendgridDomainApi - axios parameter creator
 * @export
 */
export const SendgridDomainApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Sendgridドメイン一覧取得API
         * @summary Sendgridドメイン一覧取得API
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSendgridDomains: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/admin/sendgrid_domains`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SendgridDomainApi - functional programming interface
 * @export
 */
export const SendgridDomainApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SendgridDomainApiAxiosParamCreator(configuration)
    return {
        /**
         * Sendgridドメイン一覧取得API
         * @summary Sendgridドメイン一覧取得API
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSendgridDomains(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SendgridDomain>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSendgridDomains(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * SendgridDomainApi - factory interface
 * @export
 */
export const SendgridDomainApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SendgridDomainApiFp(configuration)
    return {
        /**
         * Sendgridドメイン一覧取得API
         * @summary Sendgridドメイン一覧取得API
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSendgridDomains(options?: any): AxiosPromise<Array<SendgridDomain>> {
            return localVarFp.getSendgridDomains(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SendgridDomainApi - interface
 * @export
 * @interface SendgridDomainApi
 */
export interface SendgridDomainApiInterface {
    /**
     * Sendgridドメイン一覧取得API
     * @summary Sendgridドメイン一覧取得API
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SendgridDomainApiInterface
     */
    getSendgridDomains(options?: AxiosRequestConfig): AxiosPromise<Array<SendgridDomain>>;

}

/**
 * SendgridDomainApi - object-oriented interface
 * @export
 * @class SendgridDomainApi
 * @extends {BaseAPI}
 */
export class SendgridDomainApi extends BaseAPI implements SendgridDomainApiInterface {
    /**
     * Sendgridドメイン一覧取得API
     * @summary Sendgridドメイン一覧取得API
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SendgridDomainApi
     */
    public getSendgridDomains(options?: AxiosRequestConfig) {
        return SendgridDomainApiFp(this.configuration).getSendgridDomains(options).then((request) => request(this.axios, this.basePath));
    }
}
